import BalanceRulesRenderer from './BalanceRulesRenderer'
import {CalendarFrequencyType} from '../../../../constants'

class AccrualRulesCell extends BalanceRulesRenderer {
    _getRuleValue(ptoData) {
        return ptoData.accrualRule ? this.formatter(
            ptoData.accrualRule.value) + " " + CalendarFrequencyType.descriptionFor[ptoData.accrualRule.frequency.type] : "&ndash;";
    }

    _customClassName(ptoData) {
        return "accrualRule"
    }
}

export default AccrualRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/AccrualRulesCell.js